/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


jQuery(document).ready(function ($) {




    /**
     * 
     * PAGINA LISTA PRENOTAZIONE
     * 
     * 
     * 
     */    
    
    $(document).on('click', '.button-stampa-targhetta', function () {
        themeSpinner('show');
        scarica_targhetta(this.value);

    });

    function scarica_targhetta(id_annuncio)
    {

        var req = new XMLHttpRequest();
        req.open("GET", theme_url + '/include/targhetta.php?id_annuncio=' + id_annuncio, true);
        req.responseType = "blob";
        req.onload = function (event) {

            var blob = req.response;
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "   targhetta_" + new Date() + ".pdf";
            link.click();
            themeSpinner('hide');
        };

        req.send();

    }
    
    
    
    $(document).on('click', '.button-assegna-annuncio', function () {
        var id_annuncio = $(this).data('idannuncio');
        var beneficiario = this.value;
        
        $('#messageAssegnaOffer').html('');
        $("#messageAssegnaOffer").removeClass('alert-danger');
        $("#messageAssegnaOffer").removeClass('alert-success');
        $("#messageAssegnaOffer").hide();
        var faiAjax = true;
        var button = this;
        if (faiAjax)
        {
            var r = confirm("Sei sicuro di volere assegnare questo annuncio?");
            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'assegna_annuncio_action',
                                beneficiario: beneficiario,
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        themeSpinner('hide');
                        if (response === '1')
                        {
                            reloadScrollingToTitle();
                        }
                        else
                        {
                            $("#messageAssegnaOffer").html(response);
                            $("#messageAssegnaOffer").addClass('alert-danger');
                            $("#messageAssegnaOffer").show();
                        }


                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messageAssegnaOffer").html('Problemi nell\'assegnazione dell\' annuncio');
                        $("#messageAssegnaOffer").addClass('alert-danger');
                        $("#messageAssegnaOffer").show();
                    }

                });
            }
        }
    });
    $(document).on('click', '.button-annuncio-ritirato', function () {
        var id_annuncio = $(this).data('idannuncio');
        var beneficiario = this.value;
        
        $('#messageAssegnaOffer').html('');
        $("#messageAssegnaOffer").removeClass('alert-danger');
        $("#messageAssegnaOffer").removeClass('alert-success');
        $("#messageAssegnaOffer").hide();
        var faiAjax = true;
        var button = this;
        if (faiAjax)
        {
            var r = confirm("Confermi di avere ritirato l'oggetto?");
            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'oggetto_ritirato_action',
                                beneficiario: beneficiario,
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        themeSpinner('hide');
                        if (response === '1')
                        {
                            reloadScrollingToTitle();
                        }
                        else
                        {
                            $("#messageAssegnaOffer").html(response);
                            $("#messageAssegnaOffer").addClass('alert-danger');
                            $("#messageAssegnaOffer").show();
                        }


                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messageAssegnaOffer").html('Ritiro non confermato');
                        $("#messageAssegnaOffer").addClass('alert-danger');
                        $("#messageAssegnaOffer").show();
                    }

                });
            }
        }
    });
    $(document).on('click', '.button-annuncio-consegnato', function () {
        var id_annuncio = $(this).data('idannuncio');
        var beneficiario = this.value;
        
        $('#messageAssegnaOffer').html('');
        $("#messageAssegnaOffer").removeClass('alert-danger');
        $("#messageAssegnaOffer").removeClass('alert-success');
        $("#messageAssegnaOffer").hide();
        var faiAjax = true;
        var button = this;
        if (faiAjax)
        {
            var r = confirm("Confermi di avere consegnato l'oggetto?");
            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'oggetto_consegnato_action',
                                beneficiario: beneficiario,
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        themeSpinner('hide');
                        if (response === '1')
                        {
                            reloadScrollingToTitle();
                        }
                        else
                        {
                            $("#messageAssegnaOffer").html(response);
                            $("#messageAssegnaOffer").addClass('alert-danger');
                            $("#messageAssegnaOffer").show();
                        }


                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messageAssegnaOffer").html('Consegna non confermata');
                        $("#messageAssegnaOffer").addClass('alert-danger');
                        $("#messageAssegnaOffer").show();
                    }

                });
            }
        }
    });
    $(document).on('click', '.button-annuncio-non-ritirato', function () {
        var id_annuncio = $(this).data('idannuncio');
        var beneficiario = this.value;
        
        $('#messageAssegnaOffer').html('');
        $("#messageAssegnaOffer").removeClass('alert-danger');
        $("#messageAssegnaOffer").removeClass('alert-success');
        $("#messageAssegnaOffer").hide();
        var faiAjax = true;
        var button = this;
        if (faiAjax)
        {
            var r = confirm("Confermi di non essere più interessato all'oggetto? In caso affermativo, l'annuncio potrà essere assegnato ad altri utenti");
            if (r == true) {
                themeSpinner('show');
                $.ajax({//create an ajax request to load_page.php
                    type: "POST",
                    cache: false,
                    url: ajax_url,
                    data:
                            {
                                action: 'oggetto_non_ritirato_action',
                                beneficiario: beneficiario,
                                id_annuncio: id_annuncio

                            },
                    dataType: "html", //expect html to be returned                
                    success: function (response) {
                        themeSpinner('hide');
                        if (response === '1')
                        {
                            reloadScrollingToTitle();
                        }
                        else
                        {
                            alert(response);
                            $("#messageAssegnaOffer").html(response);
                            $("#messageAssegnaOffer").addClass('alert-danger');
                            $("#messageAssegnaOffer").show();
                        }


                    },
                    error: function () {
                        themeSpinner('hide');
                        $("#messageAssegnaOffer").html('Ci sono stati dei problemi nel rendere disponibile di nuovo l\'oggetto a tutti gli utenti');
                        $("#messageAssegnaOffer").addClass('alert-danger');
                        $("#messageAssegnaOffer").show();
                    }

                });
            }
        }
    });
});